module.exports = __webpack_public_path__ + "img/Feature.9a1eba87.jpg";